import React, { useState } from 'react';
import { Navbar } from '../components/navbar';
import { Home } from './home';
import { Help } from './help';
import { Aboutus } from './aboutus';
import { Services } from './services';
import { Footer } from '../components/footer';
import CookieNotice from './CookieNotice';
import './home.css';
import { Clientsay } from './clientsay';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  window.addEventListener('scroll', toggleVisibility);

  return (
    <button 
      className="scroll-to-top-button" onClick={scrollToTop} style={{ display: isVisible ? 'block' : 'none' }}>
      &uarr;
    </button>
  );
};

const Mainpage = () => {
  return (
    <div>
      <CookieNotice />
      <Home/>
      <Help/>
      <Aboutus/>
      <Services/>
      <ScrollToTopButton />
    </div>
  );
};

export default Mainpage;
